/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Plan_CreditsInputs */

const cs_billing_plan_credits = /** @type {(inputs: Billing_Plan_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kredity v tarifu / období`)
};

const en_billing_plan_credits = /** @type {(inputs: Billing_Plan_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Included credits / period`)
};

/**
* | output |
* | --- |
* | "Included credits / period" |
*
* @param {Billing_Plan_CreditsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_plan_credits = /** @type {((inputs?: Billing_Plan_CreditsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Plan_CreditsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_plan_credits(inputs)
	return cs_billing_plan_credits(inputs)
});